import React from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';

interface QueryPreservingLinkProps extends Omit<LinkProps, 'to'> {
    to: string;
}

const UTMQueryPreservingLink: React.FC<QueryPreservingLinkProps> = ({ to, children, ...props }) => {
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);

    const preservedParams = new URLSearchParams();

    const paramsToPreserve = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'first_source', '_gl', '_ga'];

    paramsToPreserve.forEach(param => {
        const value = searchParams.get(param);
        if (value) {
            preservedParams.set(param, value);
        }
    });

    const queryString = preservedParams.toString();
    const destination = queryString ? `${to}?${queryString}` : to;

    return (
        <Link to={destination} {...props}>
            {children}
        </Link>
    );
};

export default UTMQueryPreservingLink;
